import classNames from 'classnames';
import { FC, PropsWithChildren } from 'react';

import { TLoginLayoutMessageType } from '../LoginLayout.types';
import styles from './LoginLayoutMessage.styles.m.css';

interface ILoginLayoutMessageProps {
  className?: string;
  type?: TLoginLayoutMessageType;
}

export const LoginLayoutMessage: FC<PropsWithChildren<ILoginLayoutMessageProps>> = (props) => {
  const { type, children, className } = props;
  const containerClassName = classNames(styles.container, className, {
    [styles[`type-${type}`]]: !!type,
  });

  return <p className={containerClassName}>{children}</p>;
};
